import { createRoot, useState, useEffect } from "@wordpress/element";

import { LoginModal } from "@redcoachusa-components/login-modal";
import { Cart } from "@redcoachusa-components/cart";
import { UserLoggedIn } from "@redcoachusa-components/user-account";

import "@redcoachusa-components/cart/tailwind.css";
import "@redcoachusa-components/login-modal/tailwind.css";
import "@redcoachusa-components/user-account/tailwind.css";

function BookingLoyaltyComponents({ lang }) {
  const [session, setSession] = useState(null);

  const [loyaltyProfileDetails, setLoyaltyProfileDetails] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  const apiUrl = process.env.REACT_APP_BOOKING_URL;

  useEffect(() => {
    const getSessionData = async () => {
      const result = await fetch(`${apiUrl}/session`).then((res) => res.json());
      if (result.isLoggedIn) {
        setSession({ user: result?.user });

        window.loyaltyUser = result?.user;
      }
    };

    const getLoyaltyProfileDetails = async () => {
      try {
        const res = await fetch(`${apiUrl}/loyalty/profile-details`, {
          method: "GET",
          credentials: "include",
        });
        const result = await res.json();
        setLoyaltyProfileDetails({
          loyaltyPoints: result.loyaltyPoints,
          profile: result.profile,
          vouchers: result.vouchers,
        });
      } catch (error) {
        console.error("Error fetching loyalty profile details:", error);
      }
    };

    const loadData = async () => {
      await Promise.all([getSessionData(), getLoyaltyProfileDetails()]);
      setIsLoading(false);
    };

    loadData();
  }, []);

  const logOut = async () => {
    await fetch(`${apiUrl}/auth/log-out`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  if (session && loyaltyProfileDetails) {
    return (
      <UserLoggedIn
        session={session}
        profile={loyaltyProfileDetails.profile}
        loyaltyPoints={loyaltyProfileDetails.loyaltyPoints}
        vouchers={loyaltyProfileDetails.vouchers}
        onLogOut={logOut}
        lang={lang}
      />
    );
  }
  return <LoginModal lang={lang} />;
}

function App() {
  const lang = document.documentElement.lang || "en";
  return (
    <>
      <Cart
        currentPathname={window.location.pathname}
        previousData={null}
        lang={lang}
      />
      <BookingLoyaltyComponents lang={lang} />
    </>
  );
}

createRoot(document.getElementById("booking-components")).render(<App />);
